import { render, staticRenderFns } from "./MyRemindTask.vue?vue&type=template&id=a5ae30a2&scoped=true"
import script from "./MyRemindTask.vue?vue&type=script&lang=js"
export * from "./MyRemindTask.vue?vue&type=script&lang=js"
import style0 from "./MyRemindTask.vue?vue&type=style&index=0&id=a5ae30a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ae30a2",
  null
  
)

export default component.exports